import {
  getStoredItem,
  removeStoredItem,
  setStoredItem,
} from "@libertify.frontend/helpers";

// Shared "dismissed" flag backed by localStorage, either global
// (no id) or per-user (id passed to isDismissed/setDismissed/clear).
// Without `maxAgeDays` the flag is kept forever; with it, the flag is stored
// as `{ value, expires }` and reads as not dismissed after expiry.
export const createDismissedFlag = (
  storageKeyPrefix: string,
  maxAgeDays?: number
) => {
  const keyFor = (id?: string | number): string =>
    id !== undefined ? `${storageKeyPrefix}:${id}` : storageKeyPrefix;

  return {
    isDismissed: (id?: string | number): boolean => {
      if (typeof localStorage === "undefined") return false;
      if (maxAgeDays === undefined) {
        return localStorage.getItem(keyFor(id)) === "true";
      }
      return (
        getStoredItem(keyFor(id), { legacyMaxAgeDays: maxAgeDays }) === "true"
      );
    },

    setDismissed: (id?: string | number): void => {
      if (maxAgeDays === undefined) {
        localStorage.setItem(keyFor(id), "true");
        return;
      }
      setStoredItem(keyFor(id), "true", maxAgeDays);
    },

    clear: (id?: string | number): void => {
      removeStoredItem(keyFor(id));
    },
  };
};
